import Hero from "../components/Hero";

const Homepage = () => {
  return (
    <div className="h-screen">
      <div>
        <div>
          <div>
            <Hero />
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Homepage;
